export default "__VITE_ASSET__oqs2cSBX__"